import {
  DatePickerController,
  GroupCodesController,
  ImagesUploadController,
  NominalIdsController,
  TextFieldController,
} from '@/components/controls';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { startOfDay } from 'date-fns';
import { Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { CategoriesController } from './CategoriesController';

export function IntelligenceItemEditorDialog({
  item,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: item,
  });

  useEffect(() => {
    reset(item);
  }, [reset, item, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="notice-editor-form" onSubmit={handleSubmit(onClose)}>
      <Dialog open={isOpen && !!item} onClose={handleClose}>
        <DialogTitle>{`${item.code ? 'Edit' : 'Add'} Item`}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText gutterBottom>
              Please fill in the form below to add a notice. If groups are not
              specified then the intelligence will be visible to all.
            </DialogContentText>
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              types={['SECTOR', 'TEAM']}
            />
            <TextFieldController
              name="title"
              label="Title"
              control={control}
              rules={{ required: 'Required' }}
            />
            <DatePickerController
              name="expiryDate"
              label="Expiry Date"
              control={control}
              rules={{ required: 'Required' }}
              minDate={startOfDay(new Date())}
            />
            <TextFieldController
              name="intelligenceId"
              label="Intelligence ID"
              placeholder="XXXXXXXXX"
              control={control}
              rules={{ required: 'Required' }}
            />
            <TextFieldController
              name="message"
              label="Message"
              multiline
              minRows={8}
              control={control}
              rules={{ required: 'Required' }}
            />
            <CategoriesController
              name="categories"
              label="Categories"
              control={control}
            />
            <NominalIdsController
              control={control}
              name="nominalIds"
              label="Nominal IDs"
            />
            <ImagesUploadController name="imageSrcs" control={control} />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!item.code && (
            <Fragment>
              <Button color="error" onClick={onDelete} disabled={isDeleting}>
                Delete
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            form="notice-editor-form"
            type="submit"
            disabled={isSubmitting}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
